import { render } from "./ImportMatchColumns.vue?vue&type=template&id=78565f50&scoped=true"
import script from "./ImportMatchColumns.vue?vue&type=script&lang=js"
export * from "./ImportMatchColumns.vue?vue&type=script&lang=js"

import "./ImportMatchColumns.vue?vue&type=style&index=0&id=78565f50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78565f50"]])

export default __exports__